import script from "./ReferenceDate.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferenceDate.vue?vue&type=script&setup=true&lang=ts"

import "./ReferenceDate.vue?vue&type=style&index=0&id=324b3306&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-324b3306"]])

export default __exports__